var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCogWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 86,
    viewBox: "0 0 83 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0167 67.6708C52.6821 67.9445 51.4529 68.592 50.4725 69.5378C49.492 70.4836 48.8007 71.6887 48.4792 73.0125C46.7042 80.3292 36.2958 80.3292 34.5208 73.0125C34.2545 71.9133 33.7324 70.8926 32.997 70.0333C32.2617 69.1741 31.3338 68.5006 30.2889 68.0677C29.2441 67.6348 28.1118 67.4548 26.9842 67.5422C25.8566 67.6296 24.7656 67.9821 23.8 68.5708C17.3708 72.4875 10.0083 65.1292 13.925 58.6958C14.5129 57.7306 14.8648 56.6403 14.952 55.5134C15.0392 54.3866 14.8593 53.2551 14.427 52.2109C13.9946 51.1667 13.3219 50.2393 12.4636 49.5039C11.6054 48.7686 10.5857 48.2462 9.4875 47.9792C2.17083 46.2042 2.17083 35.7958 9.4875 34.0208C10.5867 33.7545 11.6074 33.2324 12.4667 32.497C13.3259 31.7617 13.9994 30.8338 14.4323 29.7889C14.8652 28.7441 15.0452 27.6118 14.9578 26.4842C14.8704 25.3566 14.5179 24.2656 13.9292 23.3C10.0125 16.8708 17.3708 9.50833 23.8042 13.425C27.9708 15.9583 33.3708 13.7167 34.5208 8.9875C36.2958 1.67083 46.7042 1.67083 48.4792 8.9875C48.7455 10.0867 49.2676 11.1074 50.003 11.9667C50.7383 12.8259 51.6662 13.4994 52.711 13.9323C53.7559 14.3652 54.8882 14.5452 56.0158 14.4578C57.1434 14.3704 58.2344 14.0179 59.2 13.4292C65.6292 9.5125 72.9917 16.8708 69.075 23.3042C68.4871 24.2694 68.1352 25.3597 68.048 26.4866C67.9608 27.6134 68.1407 28.7449 68.573 29.7891C69.0054 30.8333 69.6781 31.7607 70.5364 32.496C71.3946 33.2314 72.4143 33.7538 73.5125 34.0208C78.0083 35.1125 79.7417 39.4583 78.7125 43.0625",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 41C29 44.3152 30.317 47.4946 32.6612 49.8388C35.0054 52.183 38.1848 53.5 41.5 53.5C44.8152 53.5 47.9946 52.183 50.3388 49.8388C52.683 47.4946 54 44.3152 54 41C54 37.6848 52.683 34.5054 50.3388 32.1612C47.9946 29.817 44.8152 28.5 41.5 28.5C38.1848 28.5 35.0054 29.817 32.6612 32.1612C30.317 34.5054 29 37.6848 29 41Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6665 57.6667V70.1667",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6665 82.6667V82.7083",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogWhite);
export default __webpack_public_path__ + "static/media/cog-white.ff07a91455287b3beb8925b280f3c2f1.svg";
export { ForwardRef as ReactComponent };